import saga from 'Modules/dashboard/store/saga'
import reducer from 'Modules/dashboard/store/reducer'
import { makeSelectDashboard } from 'Modules/dashboard/store/selectors'
import { useDispatch, useSelector } from 'react-redux'
import {
  createPortFolio,
  deleteMemberPortFolio,
  deletePortFolioById,
  getAllCustomer,
  getAllMemberInPortfolio,
  getAssetGoals,
  getGrowthSchedules,
  getPermissionRoles,
  getPortFolioById, getPortFolioByIdEdited,
  getPortFolioByUserId, getVerifyInviteMemberPortFolio,
  postAcceptedInviteMemberPortFolio,
  postInviteMemberPortFolio,
  updateAnnualAssetGoals,
  updateCurrency,
  updateGrowthSchedules, updatePortfolioName,
  updateTimeIPO
} from 'Modules/dashboard/store/actions'
import { useInjectReducer, useInjectSaga } from 'Stores'
import { useEffect } from 'react'
import { useLocalStorage } from './useLocalStorage'
import { ROLE_TYPE } from '../Constants/permission'
import { useAuth } from './auth'

export const useDashboard = () => {
  useInjectSaga({ key: 'dashboard', saga })
  useInjectReducer({ key: 'dashboard', reducer })

  const {
    isLoading,
    error,
    success,
    customerList,
    listPortFolioByUserId,
    isSubmitted,
    portFolioById,
    updateTimeIPOStatus,
    growthSchedulesData,
    assetGoalsData,
    updateGrowthSchedulesSuccess,
    updateAssetGoalsSuccess,
    listRoles,
    listMemberInPortfolio,
    userInvite,
    portfolioSelected
  } = useSelector(
    makeSelectDashboard()
  )

  const dispatch = useDispatch()

  const createPortFolioAction = (payload) => dispatch(createPortFolio(payload))
  const getAllCustomerAction = () => dispatch(getAllCustomer())
  const getPortFolioByUserIdAction = (payload) => dispatch(getPortFolioByUserId(payload))
  const deletePortFolioByIdAction = (payload) => dispatch(deletePortFolioById(payload))
  const updateTimeIPOAction = (payload) => dispatch(updateTimeIPO(payload))
  const getPortFolioByIdAction = (payload) => dispatch(getPortFolioById(payload))
  const getAssetGoalsAction = (payload) => dispatch(getAssetGoals(payload))
  const getGrowthSchedulesAction = (payload) => dispatch(getGrowthSchedules(payload))
  const updateAnnualAssetGoalsAction = (payload) => dispatch(updateAnnualAssetGoals(payload))
  const updateGrowthSchedulesAction = (payload) => dispatch(updateGrowthSchedules(payload))
  const getAllPermissionRolesAction = (payload) => dispatch(getPermissionRoles(payload))
  const postInviteMemberPortFolioAction = (payload) => dispatch(postInviteMemberPortFolio(payload))
  const getAllMemberInPortfolioAction = (payload) => dispatch(getAllMemberInPortfolio(payload))
  const postAcceptedInviteMemberPortFolioAction = (payload) => dispatch(postAcceptedInviteMemberPortFolio(payload))
  const getVerifyInviteMemberPortFolioAction = (payload) => dispatch(getVerifyInviteMemberPortFolio(payload))
  const deleteMemberPortFolioAction = (payload) => dispatch(deleteMemberPortFolio(payload))
  const updatePortfolioNameAction = (payload) => dispatch(updatePortfolioName(payload))
  const getPortFolioByIdEditedAction = (payload) => dispatch(getPortFolioByIdEdited(payload))
  const updateCurrencyAction = (payload) => dispatch(updateCurrency(payload))

  const isCompanyAdmin = portFolioById?.role.includes(ROLE_TYPE.COMPANY_ADMIN)
  const isPortfolioAdmin = portFolioById?.role.includes(ROLE_TYPE.PORTFOLIO_ADMIN)
  const isEditor = portFolioById?.role.includes(ROLE_TYPE.EDITOR)
  const isUser = portFolioById?.role.includes(ROLE_TYPE.USER)

  return {
    isLoading,
    error,
    success,
    isSubmitted,
    listPortFolioByUserId,
    portFolioById,
    updateTimeIPOStatus,
    assetGoalsData,
    growthSchedulesData,
    updateGrowthSchedulesSuccess,
    updateAssetGoalsSuccess,
    listRoles,
    userInvite,
    listMemberInPortfolio,
    customerList,
    createPortFolioAction,
    getAllCustomerAction,
    getPortFolioByUserIdAction,
    getPortFolioByIdAction,
    deletePortFolioByIdAction,
    updateTimeIPOAction,
    getAssetGoalsAction,
    getGrowthSchedulesAction,
    updateAnnualAssetGoalsAction,
    updateGrowthSchedulesAction,
    getAllPermissionRolesAction,
    postInviteMemberPortFolioAction,
    getVerifyInviteMemberPortFolioAction,
    getAllMemberInPortfolioAction,
    postAcceptedInviteMemberPortFolioAction,
    deleteMemberPortFolioAction,
    updateCurrencyAction,
    isCompanyAdmin,
    isPortfolioAdmin,
    isEditor,
    isUser,
    updatePortfolioNameAction,
    getPortFolioByIdEditedAction,
    portfolioSelected
  }
}

// eslint-disable-next-line no-unused-vars
export const useVisibleTutorial = () => {
  const [tutorialShow, setTutorialShow, clearTutorialShow] = useLocalStorage('tutorial-show', 1)
  const { profile } = useAuth()

  useEffect(() => {
    setTutorialShow(1)
  }, [])

  const handleClick = (e) => {
    if (profile?.lastLogin === null) {
      if (e.target.nodeName === 'BUTTON' || e.target.nodeName === 'SPAN') {
        return
      }

      if (
        tutorialShow >= 1 || tutorialShow === 4) {
        setTutorialShow(tutorialShow + 1)
      }
    }
  }

  useEffect(() => {
    document.querySelector('body').addEventListener('click', handleClick)

    if (profile?.lastLogin === null && tutorialShow > 4) {
      clearTutorialShow()
      document.querySelector('body').removeEventListener('click', handleClick)
    }
    return () => document.querySelector('body').removeEventListener('click', handleClick)
  }, [tutorialShow])

  return { tutorialShow }
}
